import { Preferences } from '@capacitor/preferences';
// Funciones de almacenamiento multiplataforma
export const storage = {
    async getItem(key: string): Promise<string | null> {
      try {
        if (window.Capacitor?.isNativePlatform()) {
          const { value } = await Preferences.get({ key });
          return value;
        } else {
          return localStorage.getItem(key);
        }
      } catch (error) {
        console.error('Error getting item from storage:', error);
        return null;
      }
    },
  
    async setItem(key: string, value: string): Promise<void> {
      try {
        if (window.Capacitor?.isNativePlatform()) {
          await Preferences.set({ key, value });
        } else {
          localStorage.setItem(key, value);
        }
      } catch (error) {
        console.error('Error setting item in storage:', error);
      }
    },
  
    async removeItem(key: string): Promise<void> {
      try {
        if (window.Capacitor?.isNativePlatform()) {
          await Preferences.remove({ key });
        } else {
          localStorage.removeItem(key);
        }
      } catch (error) {
        console.error('Error removing item from storage:', error);
      }
    }
  };
  